import { defineMessages } from 'react-intl';

export const stepMessages = defineMessages({
	header: {
		id: 'step.header.madlib',
		defaultMessage: 'Set up your space',
	},
	subheader: {
		id: 'step.subheader.madlib',
		defaultMessage:
			'Projects bring your work to life, helping your team track progress, stay organized, and manage tasks.',
	},
	scrumToggleLabel: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.scrum-project-toggle-label',
		defaultMessage: 'Scrum workflow',
		description: 'Label for a toggle to switch tech team template type to scrum',
	},

	scrumToggleTooltip: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.scrum-project-toggle-tooltip',
		defaultMessage: 'Run work in sprints and keep a clear backlog to stay organized',
		description: 'Text for the tooltip for a toggle to switch tech team template type to scrum',
	},
	nextBtn: {
		id: 'onboarding-wizard.welcome-modal.left-hand-side.page-one.next-step-btn',
		defaultMessage: 'Next',
		description: 'Button to go to the next step',
	},
});
